import { NgModule } from '@angular/core';
import { addNavMenuSection, SharedModule } from '@vendure/admin-ui/core';

@NgModule({
    imports: [SharedModule],
    providers: [
        addNavMenuSection(
            {
                id: 'sellers',
                label: 'Vendedores',
                icon: 'shopping-cart',
                items: [
                    {
                        id: 'rca-sellers',
                        label: 'RCA',
                        routerLink: ['/extensions/sellers/rca-sellers'],
                    },
                    {
                        id: 'digital-consultants',
                        label: 'Consultores Digitais',
                        routerLink: ['/extensions/sellers/digital-consultants'],
                    },
                ],
            },
            'settings'
        ),
    ],
})
export class SellersNavModule {}
